import { AfterViewInit, Component, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'phoenix-scroll-to-top',
  template: `
    <div
      class="scroll-to-top__back"
      [ngClass]="{ 'scroll-to-top__show': windowScrolled }"
    >
      <button
        (click)="scrollToTop()"
        class="round-btn"
        color="primary"
        mat-mini-fab
      >
        <mat-icon class="md-24">arrow_upward</mat-icon>
      </button>
    </div>
  `,
  styles: [
    `
      .scroll-to-top {
        &__back {
          @apply absolute bottom-4 right-4 opacity-0 transition-all ease-in-out duration-200;
        }

        &__show {
          @apply opacity-20 transition-all ease-in-out duration-200 z-50;
        }

        &__show:hover {
          @apply opacity-100;
        }
      }
    `,
  ],
  standalone: false,
})
export class ScrollToTopComponent implements AfterViewInit {
  @Input() containerId!: string;
  windowScrolled = false;
  divContainer!: any;

  constructor(readonly renderer: Renderer2) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.divContainer = document.getElementById(this.containerId);
      this.divContainer &&
        this.divContainer.addEventListener('scroll', this.onScroll);
    });
  }

  private onScroll = () => {
    this.windowScrolled = this.divContainer && this.divContainer.scrollTop > 0;
  };

  scrollToTop() {
    const container = this.renderer.selectRootElement(
      `#${this.containerId}`,
      true
    );
    container.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
